import { takeEvery, put, call, all, fork } from "redux-saga/effects";

// Login Redux States
import { GET_DROP_DOWN_LIST_DATA } from "./actionTypes";
import { getDropDownListSuccess, getDropDownListError } from "./actions";

import { getDropDownData } from "../../helpers/fakebackend_helper";

function* fetchDropDownList() {
  try {
    const response = yield call(getDropDownData);
    yield put(getDropDownListSuccess(response));
  } catch (error) {
    yield put(getDropDownListError(error));
  }
}

export function* watchFetchDropDownList() {
  yield takeEvery(GET_DROP_DOWN_LIST_DATA, fetchDropDownList);
}

function* dropDownListSaga() {
  yield all([fork(watchFetchDropDownList)]);
}

export default dropDownListSaga;
